import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Loader from 'src/components/common/Loader';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { archLevel } from 'src/data/config';
import { useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { useAppDispatch } from 'src/store/hooks';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useSiteContactInfo } from '../../steps/useSitecontactinfo';
import { useMonitoringVisitLog } from '../MonitoringVisitLogs/useMonitoringVisitLog';
import '../studylogStyles.scss';
import DataGridFollowUp from './DataGridFollowUp';
import { useIMVFollowUpVisit } from './useIMVFollowUp';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
const FollowUp: React.FunctionComponent<any> = ({ setStudyLogOpen, setFollowUp }: any) => {
  const dispatch = useAppDispatch();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const {
    allImvFollowDataError,
    allImvFollowDataIsError,
    getAllimvFollowUpData,
    allPublishImvFollowDataError,
    allPublishImvFollowDataIsError,
    getPublishimvFollowUpData
  } = useIMVFollowUpVisit();
  const { getSiteStudyPersonnelQueryData } = useSiteContactInfo();
  const [siteStudyPersonnelsData, setSiteStudyPersonnelsData] = useState({});
  const { selectedAppSection } = useSelectedAppInfo();
  const { checkPermission } = usePermissionWrapper();
  const [rows, setRows] = React.useState([]);
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const [lettersListBackOn, setLettersListBackOn] = useState(false);
  const [dataGridShow, setDataGridShow] = useState(false);
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();

  const getFollowUpVisit = async () => {
    setDataGridShow(true);
    setRows([]);
    const temp = checkPermission('publishview_imvfollowup_letter')
      ? await getPublishimvFollowUpData({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: `${archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP}`
        })
      : await getAllimvFollowUpData({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: `${archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP}`
        });
    const allMonitoringResponse: any = await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: selectedAppSection,
      data: {}
    });
    const tempRows: any = [];
    if (temp.isSuccess) {
      temp?.data.map((Data: any) => {
        const tempRowData = {
          id: Data.id,
          visit_name: Data.visit_name,
          site_id: Data.site_id,
          created_by: Data.created_by,
          updated_by: Data.updated_by,
          visit_type: Data.visit_type,
          start_date: getPreferredDateTimeInLocal(Data.start_date),
          updated_on: getPreferredDateTimeInLocal(Data.updated_on),
          major_version: Number(Data.major_version).toFixed(1).toString(),
          tp_document_id: Data.tp_document_id
        };
        if (allMonitoringResponse.data && allMonitoringResponse.data.selected_data.length > 0) {
          allMonitoringResponse.data.selected_data.map((visit: any) => {
            if (visit.visit_type === 'Interim Monitoring Visit' && visit.id === Data.id) {
              tempRows.push({
                ...tempRowData,
                start_date: visit.actual_start_date === null ? Data.start_date : visit.actual_start_date
              });
            }
          });
        } else {
          tempRows.push({
            ...tempRowData
          });
        }
      });
      if (tempRows.length > 0) {
        setRows(tempRows);
      }
    } else if (temp?.isError) {
      setRows([]);
    }
    setDataGridShow(false);
  };
  //Calling Followup visit list api on hierarchy level change
  useEffect(() => {
    getFollowUpVisit();
  }, [studyId, selectedCountry, selectedSite, isHierarchyLevelClosed, lettersListBackOn]);
  const { getAllMonitoringVisits } = useMonitoringVisitLog();
  useEffect(() => {
    getFollowUpVisit();
    getSiteStudyPersonnels();
  }, []);
  useEffect(() => {
    if (allImvFollowDataIsError) {
      setRows([]);
      const err: any = allImvFollowDataError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
      setDataGridShow(false);
    } else if (allPublishImvFollowDataIsError) {
      setRows([]);
      const err: any = allPublishImvFollowDataError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Letter is not published',
            severity: 'error'
          })
        );
      }
      setDataGridShow(false);
    }
  }, [allImvFollowDataIsError, allImvFollowDataError, allPublishImvFollowDataError, allPublishImvFollowDataIsError]);
  const getSiteStudyPersonnels = async () => {
    try {
      const res: any = await getSiteStudyPersonnelQueryData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME
      });
      if (res.isSuccess) {
        setSiteStudyPersonnelsData(res.data);
      } else {
        setSiteStudyPersonnelsData({});
      }
    } catch (error) {
      // Empty
    }
  };
  return (
    <div>
      <Loader />
      <Box sx={{ width: '100%' }}>
        <DataGridFollowUp
          rows={rows}
          isLoading={dataGridShow}
          setFollowUp={setFollowUp}
          setStudyLogOpen={setStudyLogOpen}
          siteStudyPersonnelsData={siteStudyPersonnelsData}
          lettersListBackOn={lettersListBackOn}
          setLettersListBackOn={setLettersListBackOn}
        />
      </Box>
    </div>
  );
};
export default FollowUp;
